module.exports = __webpack_public_path__ + "static/media/upload.a8fca043.svg";